import React from 'react';
import { connect } from 'react-redux';
import { createPureComponent } from 'module/Common';
import { Link } from './Link.s';
import { MenuAction } from 'module/Redux/Menu';
import { MenuItemExternalLink } from 'module/Model/Menu';
import { ReduxCompatibleDispatch } from 'lib/redux-stabilizer';
import { State } from 'module/Redux';

type StateProps = {};

const mapStateToProps = (state: State): StateProps => ({});

type DispatchProps = {
  closeMenu: () => void;
};

const mapDispatchToProps = (dispatch: ReduxCompatibleDispatch): DispatchProps => ({
  closeMenu: () => dispatch(MenuAction.setClose()),
});

type OwnProps = {
  item: MenuItemExternalLink;
};

type Props = StateProps & DispatchProps & OwnProps;

const ItemExternalLinkComp = createPureComponent<Props>('ItemExternalLink', ({ item, closeMenu }) => {
  return (
    <Link
      href={MenuItemExternalLink.getUrl(item)}
      isActive={false}
      target={MenuItemExternalLink.newTab(item) ? '_blank' : ''}
    >
      {MenuItemExternalLink.getName(item)}
    </Link>
  );
});

export const ItemExternalLink = connect(mapStateToProps, mapDispatchToProps)(ItemExternalLinkComp);



// WEBPACK FOOTER //
// ./src/module/View/Menu/Items/ItemExternalLink.tsx